import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { MessageInfoState } from 'typings/reduxStore'
import { MessageDetail } from 'typings/message'

export const initState: MessageInfoState = {
  dataListInbox: [],
  inboxCount: 0,
  dataListOutbox: [],
  outboxCount: 0,
  isDataLoading: true,
  isMessageResponseFail: false,
  selectedMessageDetail: {} as MessageDetail,
  isDetailMessageResponseFail: false,
  messageType: 'inbox',
  selectedMessageId: '',
  gridOption: {
    columnID: '',
    currentPage: 1,
    limit: 5,
    sortColumn: '',
    sortOrder: ''
  },
  error: false,
  errorMessage: '',
  replyResponseStatus: '',
  replyErrorMessage: '',
  hasMessageSent: false
}

const messageSlice = createSlice({
  name: 'messageSlice',
  initialState: initState,
  reducers: {
    updateMessageState: (
      state: MessageInfoState,
      action: PayloadAction<MessageInfoState>
    ) => {
      return {
        ...state,
        ...action.payload
      }
    }
  }
})

export const { updateMessageState } = messageSlice.actions

export default messageSlice.reducer
